import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {Button, Form, Input, Modal, Upload, UploadProps,Image} from "antd";
import {useTranslation} from "react-i18next";
import TextArea from "antd/es/input/TextArea";
import {imgPathPerfix, isStringNullOrEmpty} from "@/utils";
import {DeleteOutlined, InboxOutlined} from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import "./DialogExportInfo.css"
import {LOGIN_ACCOUNT, LOGIN_USERNAME} from "@/Const";
import Global from "@/global"
import {IconClose} from "@/Icon";

const DialogExportInfo = forwardRef((props:{isShowDialog:boolean,onCloseDialogEvent:any,onExportEvent:any},ref)=>{
    useImperativeHandle(ref,()=>({
        onSetExportInfo:onSetExportInfo
    }));
    const {t} = useTranslation();
    const [uploadBase64Image,setUpdateBase64Image] = useState<string>('');
    const [isShowImagePreview,setIsShowImagePreview] = useState(false);
    const [formInitValues,setFormInitValues] = useState({creator:Global.g_userInfo?.username||'',supportContent:Global.g_userInfo?.email||''});
    const [dialogTitle,setDialogTitle] = useState('');
    const onSetExportInfo = (info,title,szDialogTitle)=>{
        if (info != undefined){
            setFormInitValues(info);
            setUpdateBase64Image(info.cover);//封面....
        }else{
            if (!isStringNullOrEmpty(title)){
                setFormInitValues({...info,title:title})
            }
            setUpdateBase64Image('');
        }
        setDialogTitle(szDialogTitle)
    }

    const onFinish = (values: any) => {
        console.log('Success:', values);
        values.cover = uploadBase64Image;
        props.onExportEvent(values);
        props.onCloseDialogEvent();
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    const uploadProps:{ beforeUpload: (file) => string } = {
        beforeUpload:(file)=>{
            let reader = new FileReader();
            reader.onload = function (e){
                setUpdateBase64Image(e.target.result as string);
            }
            reader.readAsDataURL(file);

            return Upload.LIST_IGNORE
        }
    }

    /**
     * 移除图片
     */
    const onRemoveImage = (e)=>{
        e.stopPropagation();
        Modal.confirm({
            content:t("Comfirm remove thumbnail"),
            okText:t("Remove"),
            cancelText:t("Cancel"),
            onOk(){
                setUpdateBase64Image('');
            }
        })
    }

    /**
     * 显示图片
     */
    const onShowImageViewPreview = ()=>{
        setIsShowImagePreview(true);
    }

    return(
        <div>
            <Modal width={'640px'} closeIcon={<IconClose/>} visible={props.isShowDialog} closable={true} onCancel={()=>props.onCloseDialogEvent()} footer={''} destroyOnClose={true}>
                <div>
                    <h3>{dialogTitle}</h3>
                    <div style={{height:'12px'}}></div>
                    <Form
                        colon={false}
                        labelAlign={"left"}
                        initialValues={formInitValues}
                        style={{marginTop:'12px'}}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off">
                        <Form.Item<any>
                            label={t("Title")}
                            name="title"
                            rules={[{ required: true, message: t('Input export title') }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item<any>
                            label={t("Thumbnail")}
                            name="thumbnail"
                            rules={[{required:false,message:t("Select thumb")}]}
                        >
                            <div>
                                <Dragger {...uploadProps}>
                                    <div style={{borderRadius:'8px', height:'180px',display:'flex',justifyContent:'center',flexDirection:'column',position:'relative'}}>
                                        <p className="ant-upload-drag-icon">
                                            <img className='img-small' src={imgPathPerfix()+"small_image.png"}/>
                                        </p>
                                        <p className="ant-upload-hint">
                                            {t("Drag and drop")}
                                        </p>
                                        <p className="ant-upload-hint">{t("Recommended size")}</p>
                                    </div>
                                </Dragger>

                                <div>
                                    <img  style={{width:'100%',height:'100%',objectFit:'cover', position:"absolute",left:'0px',top:'0px',display:isStringNullOrEmpty(uploadBase64Image)?'none':'inherit'}} src={uploadBase64Image}/>
                                    <div onClick={onShowImageViewPreview} className='div-image-alpha' style={{visibility:isStringNullOrEmpty(uploadBase64Image)?'hidden':'visible'}}>
                                        <img onClick={onRemoveImage} className='img-medium' src={imgPathPerfix()+"delete_red.png"}/>
                                    </div>
                                </div>
                            </div>
                        </Form.Item>

                        <Form.Item<any>
                            label={t("Description")}
                            name="description"
                        >
                            <TextArea style={{resize:'none',height:'76px'}}/>
                        </Form.Item>

                        <Form.Item<any>
                            label={t("Creator")}
                            name="creator"
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item<any>
                            label={t("Support content")}
                            name="supportContent"
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item<any>
                            label={t("Version")}
                            name="version"
                        >
                            <Input />
                        </Form.Item>

                        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                            <Button className='large-w-button' onClick={()=>props.onCloseDialogEvent()}>{t("Cancel")}</Button>
                            <Button className='large-w-button button-solid-style'
                                    type="primary"
                                    style={{marginLeft:'26px'}}
                                    htmlType={"submit"}>{t("Export")}</Button>
                        </div>

                    </Form>


                </div>
            </Modal>

            <Image
                width={20}
                style={{display: 'none', zIndex: 9999999}}
                preview={{
                    visible:isShowImagePreview,
                    src: uploadBase64Image,
                    onVisibleChange: (value) => {
                        setIsShowImagePreview(value);
                    },
                }}
            />
        </div>
    )
});

export default DialogExportInfo;